import { useEffect, useState } from 'react';

import { apiUrl } from './apiBase';

export interface PublicJsonState<T> {
  data: T | null;
  loading: boolean;
  error: string | null;
}

export function usePublicJson<T>(path: string | null): PublicJsonState<T> {
  const [state, setState] = useState<PublicJsonState<T>>({ data: null, loading: true, error: null });

  useEffect(() => {
    if (path === null) {
      return;
    }

    let cancelled = false;
    setState({ data: null, loading: true, error: null });

    fetch(apiUrl(path))
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        return response.json() as Promise<T>;
      })
      .then((data) => {
        if (!cancelled) {
          setState({ data, loading: false, error: null });
        }
      })
      .catch((failure: unknown) => {
        if (!cancelled) {
          setState({ data: null, loading: false, error: failure instanceof Error ? failure.message : 'error' });
        }
      });

    return () => {
      cancelled = true;
    };
  }, [path]);

  return state;
}

export default usePublicJson;
